export default "__VITE_ASSET__bCKUnfjI__"